const config = {
  apiKey: 'AIzaSyCsMOyJJ3wSKs05F5sULcRlo0vi2bb9LAo',
  authDomain: 'foxyjot-cms.firebaseapp.com',
  databaseURL: 'https://foxyjot-cms.firebaseio.com',
  projectId: 'foxyjot-cms',
  storageBucket: 'foxyjot-cms.appspot.com',
  messagingSenderId: '307874662249'
}

export default config



// WEBPACK FOOTER //
// ./src/app/firebase_config/config.js